"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Label_1 = require("../Label/Label");
const polished_1 = require("polished");
const FormGroupContext_1 = tslib_1.__importDefault(require("./FormGroupContext"));
const styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
const uniqueId = require('lodash.uniqueid');
const Wrapper = styled_components_1.default.div `
  margin-bottom: ${({ theme }) => (0, polished_1.rem)(theme.formGroup.bottomMargin)};
  > ${Label_1.Wrapper} {
    margin-bottom: ${({ theme }) => (0, polished_1.rem)(theme.formGroup.labelGutter)};
  }
`;
class FormGroup extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            id: uniqueId(),
        };
    }
    render() {
        const { children } = this.props;
        return (React.createElement(FormGroupContext_1.default.Provider, { value: this.state },
            React.createElement(Wrapper, null, children)));
    }
}
exports.default = FormGroup;
